import { BarcodeReader } from 'dynamsoft-javascript-barcode'
BarcodeReader.license =
  'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAxNjY4MzA1LVRYbFhaV0pRY205cVgyUmljZyIsIm9yZ2FuaXphdGlvbklEIjoiMTAxNjY4MzA1IiwiY2hlY2tDb2RlIjotMTAwNzEwMjkxNX0='
BarcodeReader.engineResourcePath = 'https://cdn.jsdelivr.net/npm/dynamsoft-javascript-barcode/dist/'
